// extracted by mini-css-extract-plugin
export default {"item":"styles_item__-oPdy","label":"styles_label__ZLSbA","prefixIcon":"styles_prefixIcon__ikqN1","suffixIcon":"styles_suffixIcon__8XdVT"};